module.exports = __webpack_public_path__ + "static/media/salisbury-19.531ae806.jpg";